import {FC, memo} from 'react'

export const genericMemo: <T>(Component: T) => Pick<FC, 'displayName'> & T = memo
